import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  update: false,
  gameDetails: [],
  fetchLoading: false,
  singleGame: null,
};

const slice = createSlice({
  name: "gameDetail",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updateGameDetailSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.games = state.games.map((game) => {
        if (game.id === action.payload.id) {
          return action.payload;
        }
        return game;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.update = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getGameDetailSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.games = action.payload;
    },

    // GET SINGLE SUCCESS
    getSingleGameSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleGame = action.payload;
    },

    // GET PRODUCTS
    createGameDetailSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.games = [...state.games, action.payload];
    },

    // DELETE EVENT
    deleteGameSuccess(state, action) {
      const gameId = action.payload;
      state.games = state.games.filter((game) => game.id !== gameId);
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

export function createGameDetail({ data, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("game-details", data);
      dispatch(slice.actions.createGameDetailSuccess(response.data.data));
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateGameDetail({ id, data, enqueueSnackbar, setOpenEdit }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`game-details/${id}`, data);
      dispatch(slice.actions.updateGameDetailSuccess(response.data.data));
      // setOpenEdit(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}
